import React from 'react';

export default class Page2 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">

                                            <div className="lightgreencontentbg keyquestionpad">

                                                <p><span className="brown boldtext startalpha">2.</span><span
                                                    className="startalpha1">The 2 paid confederates were instructed to call the slides green on approximately 2/3 of the trials and in random order.</span>
                                                </p>
                                                <p><span className="brown boldtext"
                                                         style={{paddingRight:'8px'}}>3.</span>There were no paid
                                                    confederates.</p>


                                                <p>The minority only influenced the view of the real
                                                    participants in the first condition;
                                                    surprisingly 8.5% of real participants changed their view
                                                    and called the slides green and
                                                    32% of the real participants reported having seen green
                                                    slides at least once.</p>
                                                <div className="uiheading"><p>Moscovici concluded that for a
                                                    minority to have an impact they have to be active
                                                    and consistent and this leads others within the group to
                                                    perceive them as more confident
                                                    and competent.</p></div>
                                            </div>


                                            <div className="border_subtitle">This tool can help</div>
                                            <p>At times, everyone questions whether they will be able to create
                                                their desired impact. This tool is
                                                about <span
                                                    className="brown brownbold"> how to manage your impact </span> and
                                                will help you better understand the type of impact you
                                                would like to achieve in various situations. It also helps you
                                                to evaluate your own style, why it can
                                                be ineffective and how to develop your approach to create the
                                                impact you would like to have.</p>


                                            <div className="circle_title">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">WHY IS IMPACT IMPORTANT?</span>
                                            </div>
                                            <p>Impact is important at work. Regardless of your intention it will
                                                be the impact of your behaviour and what you say that people
                                                will identify with and act upon. As impact is not necessarily
                                                linked to intention. This means it can be difficult to pin down
                                                and may be controversial at times.</p>
                                            <p>Ask yourself,<span className="subtiltereg"> ‘how aware am I of the impact I have on other people?’</span> You
                                                may find that although
                                                you think you understand your impact the reality might be less
                                                clear cut. Follow this question up
                                                with the same one to those around you to see whether there is a
                                                difference. The difference
                                                between what you meant and how it was received in a given
                                                situation can lead to different
                                                reactions and behaviours from those around you. For example, it
                                                could mean developing trust in
                                                a relationship and being effective, or developing an ineffective
                                                relationship that leads to those
                                                around you being more challenging than they might have been
                                                otherwise.</p>
                                            <p>This reality can highlight the importance of impact. Awareness of
                                                impact can lead to better
                                                understanding and appreciation in your transactions with others.
                                                Below is a step-by-step account
                                                to get you started on developing your impact.</p>
                                            <div className="border_subtitle" style={{marginBottom: '24px'}}>The
                                                next page outlines a four-stage process to manage your impact:
                                            </div>

                                            <div className="lightgreencontentbg keyquestionpad">

                                                <p><span className="brown boldtext"
                                                         style={{paddingRight:'6px'}}>1.</span> Develop
                                                    self-awareness</p>
                                                <p><span className="brown boldtext"
                                                         style={{paddingRight:'6px'}}>2.</span> Identify your
                                                    desired impact</p>
                                                <p><span className="brown boldtext"
                                                         style={{paddingRight:'6px'}}>3.</span> Act</p>
                                                <div className="uiheading"><p><span className="brown boldtext"
                                                                                    style={{paddingRight:'6px'}}>4.</span> Evaluation.
                                                </p></div>
                                            </div>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page1')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    ;
    }
    }